<template>
  <div class="row">
    <div v-if="bottle" class="col-12">
      <Heading>Nr. {{ bottle.serial }}</Heading>
      <div class="border border-light p-5">
        <div class="row">
          <div class="col-4">
            <b class="text-primary">Standort:</b><br>
            <bottle-state :item="bottle"/>
          </div>
          <div class="col-4">
            <b class="text-primary">Flaschentyp:</b><br>
            <data-select :options="bottleTypes" v-model="bottle.type"/>
          </div>
          <div class="col-4">
            <b class="text-primary">Fällig:</b><br>
            <data-input :value="dateWithFormat(bottle.due, 'YYYY-MM-DD')" @input="setNewDate" type="date"/>
          </div>
          <div class="col-3 offset-6 text-right">
            <button @click="cancel" class="btn btn-secondary btn-block mt-5 btn-sm">Abbrechen</button>
          </div>
          <div class="col-3 text-right">
            <button @click="save" class="btn btn-primary btn-block mt-5 btn-sm">Speichern</button>
          </div>
        </div>
      </div>
      <bottle-action-log :actions="bottle.bottle_actions" class="mt-5"/>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment'
import SearchBar from "../../components/admin/SearchBar";
import Heading from "../../components/admin/Heading";
import {mapActions, mapState} from "vuex";
import BottleState from "../../components/admin/BottleState";
import timeFormatter from "../../mixins/timeFormatter";
import BottleActionLog from "../../components/admin/BottleActionLog";
import DataInput from "../../components/DataInput";
import DataSelect from "../../components/DataSelect";

export default {
  name: "BottleEdit",
  components: {DataSelect, DataInput, BottleActionLog, BottleState, Heading, SearchBar},
  mixins: [timeFormatter],
  data() {
    return {
      bottle: null,
    }
  },
  computed: {
    ...mapState({
      bottleTypes: state => state.bottleTypes
    })
  },
  mounted() {
    this.fetchBottleDetails({id: this.$route.params.bottle_id})
        .then(res => this.bottle = res)
        .catch(this.apiErrorHandler)
  },
  methods: {
    ...mapActions({
      fetchBottleDetails: "Api/Bottles/get",
      modifyBottleDetails: "Api/Bottles/modify"
    }),
    setNewDate(date) {
      Vue.set(this.bottle, 'due', moment.parseZone(date).toISOString());
    },
    save() {
      this.modifyBottleDetails(this.bottle)
          .then(result => this.$router.back())
          .catch(this.apiErrorHandler)
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>
